export enum EMessageType {
  HUMAN = 'human',
  AI = 'ai',
  SYSTEM = 'system',
  TOOL = 'tool',
  FUNCTION = 'function',
  CHAT = 'chat',
  PLACEHOLDER = 'messages list',
}
